import {useEffect} from "react";

import {withGTM} from "../../../components/hoc/withGTM";
import {SimpleContainer} from "../../../components/layout/SimpleContainer";
import {Newsletter} from "../../../components/Newsletter";
import {pageviewAlgolyticsHit} from "../../tracking/algolytics/pageview_hits";
import {usePageview} from "../../tracking/use_pageview";
import {ViewType} from "../../tracking/view_type";
import {BigDataBehind} from "../components/BigDataBehind";
import {BigDataSolutions} from "../components/BigDataSolutions";
import {LandingMarketNewsArticles} from "../components/LandingMarketNewsArticles";
import {LandingMarketNewsFeatured} from "../components/LandingMarketNewsFeatured";

export const Landing = withGTM(() => {
    usePageview(() => {
        pageviewAlgolyticsHit({viewType: ViewType.LANDING});
    });

    useEffect(() => {
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    return (
        <SimpleContainer>
            <LandingMarketNewsFeatured />

            <LandingMarketNewsArticles />

            <BigDataSolutions />

            <BigDataBehind />

            <Newsletter variant="landing" id="newsletter" />
        </SimpleContainer>
    );
});
